export default "__VITE_ASSET__f85e77e6__"